import Vue from 'vue'
import VCharts from 'v-charts'
import App from './App.vue'
import Vuetify from 'vuetify'
import router from './router'
import store from './vuex/store'
import { sync } from 'vuex-router-sync'
import VeeValidate from 'vee-validate';
import 'vuetify/dist/vuetify.css'
import "babel-polyfill";
import DateFormate from './mixins/dateFormate'
import ValidationRules from './mixins/validationRules'
import GlobalMethods from './mixins/globalMethods'

let UtilService = require("./services/util.service");
let Encrypted = require("./services/encrypted");

import Snackbar from './components/global/snackbar.vue';

require('./assets/css/style.css');
require('../assets/css/printReport.css');
require('../assets/css/printInspectionForms.css');

Vue.use(VCharts)
Vue.use(Vuetify)
sync(store, router)

const behaviors = ['eager', 'aggressive', 'none'];

Vue.use(VeeValidate, {
            statusEvents: {
                'pristine': 'blur',
                'invalid': 'change',
                'valid': 'blur'
            }
        });

//Vue.use(VeeValidate)


Vue.prototype.$actionButton = 'not_approved'

// This is a global mixin, it is applied to every vue instance
Vue.mixin(DateFormate)
Vue.mixin(ValidationRules)
Vue.mixin(GlobalMethods)


Vue.component('Snackbar',Snackbar);
new Vue({
	el: '#app',	
	router,
	store,
	render: h => h(App),
	async beforeCreate() {	
		//console.log('beforeCreate');	
		this.$store.commit('SET_MODULE_NAME', localStorage.getItem("module")); 
		 
		let proInfo = UtilService.getProjectInfo();		
		this.$store.commit('SET_PROJECT_INFO', proInfo);

		let permission = sessionStorage.getItem("p");
		if(permission){
			let decodeString = Encrypted.base64_decode(permission);
			this.$store.commit("SET_USER_ROLE", JSON.parse(decodeString));	
		}
		
	},	
	async created()
	{
		//console.log('created');
		this.$store.commit('SET_USER_ROLE_DATA', localStorage.getItem("roleDetails"));
	}

})



// WEBPACK FOOTER //
// ./src/main.js